import profileConstants from "../_constants/profileConstants";
import profileService from "../_services/profileService";
import { firestore, auth } from "../_firebase";
import Collection from "../_collections";

/* ---------------------------------------------------
  VIEW MEMBER
----------------------------------------------------- */

export const viewMember = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;
  let unsubscribeProfileActions;
  let profileExists = false;
  let unsubscribeToProfile = firestore
    .collection(Collection.USERS)
    .doc(profileId)
    .onSnapshot(doc => {
      if (doc.exists) {
        profileExists = true;
        //get the members data
        dispatch(viewMemberProfileSuccess(doc.data()));
        //mark that you viewed the profile
        //profileService.markProfileViewed(profileId);
        //listen to changes in activities
        unsubscribeProfileActions = listenToChangesInActivityForProfile(
          profileId,
          dispatch
        );
      } else {
        //member does not exist redirect to home
        if (onError) {
          onError();
        }
      }
    });

  return () => {
    profileExists ? unsubscribeProfileActions() : null;
    unsubscribeToProfile();
  };
};

/* ---------------------------------------------------
  CLEAR MEMBER PROFILE 
----------------------------------------------------- */
const clearMemberProfile = payload => ({
  type: profileConstants.CLEAR_MEMBER_PROFILE,
  payload
});

/* ---------------------------------------------------
  LISTEN TO CHANGES IN ACTIVITY FOR PROFILE
----------------------------------------------------- */
const listenToChangesInActivityForProfile = (profileId, dispatch) => {
  const userId = auth.currentUser.uid;
  //LIKE STATUS
  let unsubscribeProfileLiked = firestore
    .collection(Collection.PROFILE_LIKES)
    .where("userId", "==", userId)
    .where("profileId", "==", profileId)
    .onSnapshot(snapshot => {
      if (snapshot.size === 0) {
        console.log("Profile Not Liked");
        dispatch(changeProfileLikedStatus(false));
      } else {
        console.log("Profile Liked");
        dispatch(changeProfileLikedStatus(true));
      }
    });
  //EXPRESS INTERESTS STATUS
  let unsubscribeProfileInterest = firestore
    .collection(Collection.INTERESTS)
    .where("userId", "==", userId)
    .where("profileId", "==", profileId)
    .onSnapshot(snapshot => {
      if (snapshot.size === 0) {
        dispatch(changeProfileInterestStatus(false));
      } else {
        dispatch(changeProfileInterestStatus(true));
      }
    });
  //SHORTLIST STATUS
  let unsubscribeProfileShortlisted = firestore
    .collection(Collection.SHORTLISTS)
    .where("userId", "==", userId)
    .where("profileId", "==", profileId)
    .onSnapshot(snapshot => {
      if (snapshot.size === 0) {
        dispatch(changeProfileShortlistedStatus(false));
      } else {
        dispatch(changeProfileShortlistedStatus(true));
      }
    });
  //SAVE STATUS
  let unsubscribeProfileSaved = firestore
    .collection(Collection.SAVES)
    .where("userId", "==", userId)
    .where("profileId", "==", profileId)
    .onSnapshot(snapshot => {
      if (snapshot.size === 0) {
        dispatch(changeProfileSavedStatus(false));
      } else {
        dispatch(changeProfileSavedStatus(true));
      }
    });

  //ADDED TO FAVORITE STATUS
  let unsubscribeProfileFavorited = firestore
    .collection(Collection.FAVORITES)
    .where("userId", "==", userId)
    .where("profileId", "==", profileId)
    .onSnapshot(snapshot => {
      if (snapshot.size === 0) {
        dispatch(changeProfileAddedToFavoriteStatus(false));
      } else {
        dispatch(changeProfileAddedToFavoriteStatus(true));
      }
    });

  //RQUEST PENDING FOR CONNECT
  let unsubscribeRequestPendingForConnect = firestore
    .collection(Collection.CONNECTS)
    .where("userId", "==", userId)
    .where("profileId", "==", profileId)
    .onSnapshot(snapshot => {
      //TO-DO listen for doc changes
      snapshot.docChanges().forEach(change => {
        //added
        if (change.type === "added") {
          let docData = change.doc.data();
          //ADDED WAS PENDING STATUS
          if (docData.status === profileConstants.CONNECT_PENDING_STATUS) {
            dispatch(changeRequestPendingForConnectStatus(true));
            dispatch(changeConnectedStatus(false));
          }
          //ADDED WAS APPROVED STATUS
          if (docData.status === profileConstants.CONNECT_APPROVED_STATUS) {
            dispatch(changeConnectedStatus(true));
            dispatch(changeRequestPendingForConnectStatus(false));
          }
        }
        //modified
        if (change.type === "modified") {
          let docData = change.doc.data();
          //MODIFIED WAS PENDING STATUS
          if (docData.status === profileConstants.CONNECT_PENDING_STATUS) {
            dispatch(changeRequestPendingForConnectStatus(true));
            dispatch(changeConnectedStatus(false));
          }
          //MODIFIED WAS APPROVED STATUS
          if (docData.status === profileConstants.CONNECT_APPROVED_STATUS) {
            dispatch(changeConnectedStatus(true));
            dispatch(changeRequestPendingForConnectStatus(false));
          }
        }
        //removed
        if (change.type === "removed") {
          dispatch(changeRequestPendingForConnectStatus(false));
          dispatch(changeConnectedStatus(false));
        }
      });
    });

  //RQUESTED TO CONNECT
  let unsubscribeRequestedToConnect = firestore
    .collection(Collection.CONNECTS)
    .where("userId", "==", profileId)
    .where("profileId", "==", userId)
    .onSnapshot(snapshot => {
      //TO-DO listen for doc changes
      snapshot.docChanges().forEach(change => {
        //added
        if (change.type === "added") {
          let docData = change.doc.data();
          //ADDED WAS PENDING STATUS
          if (docData.status === profileConstants.CONNECT_PENDING_STATUS) {
            dispatch(changeRequestedToConnectStatus(true));
            dispatch(changeConnectedStatus(false));
          }
          //ADDED WAS APPROVED STATUS
          if (docData.status === profileConstants.CONNECT_APPROVED_STATUS) {
            dispatch(changeConnectedStatus(true));
            dispatch(changeRequestedToConnectStatus(false));
          }
        }
        //modified
        if (change.type === "modified") {
          let docData = change.doc.data();
          //MODIFIED WAS PENDING STATUS
          if (docData.status === profileConstants.CONNECT_PENDING_STATUS) {
            dispatch(changeRequestedToConnectStatus(true));
            dispatch(changeConnectedStatus(false));
          }
          //MODIFIED WAS APPROVED STATUS
          if (docData.status === profileConstants.CONNECT_APPROVED_STATUS) {
            dispatch(changeConnectedStatus(true));
            dispatch(changeRequestedToConnectStatus(false));
          }
        }
        //removed
        if (change.type === "removed") {
          dispatch(changeRequestPendingForConnectStatus(false));
          dispatch(changeConnectedStatus(false));
        }
      });
    });

  //PRIVACY SETTING
  let unsubscribePrivacySetting = firestore
    .collection(Collection.USERS)
    .doc(profileId)
    .collection(Collection.PRIVACY_SETTING)
    .doc(profileId)
    .onSnapshot(snapshot => {
      const privacy = snapshot.data();
      if (privacy.images) {
        dispatch(getMemberTopImages(profileId));
      } else {
        dispatch(clearMemberTopImages());
      }
      if (privacy.phone) {
        dispatch(getMemberMobileNumber(profileId));
      } else {
        dispatch(clearMemberMobileNumber());
      }
      dispatch(viewMemberPrivacySuccess(snapshot.data()));
    });

  let unsubscribe = () => {
    unsubscribeProfileFavorited();
    unsubscribeProfileInterest();
    unsubscribeProfileLiked();
    unsubscribeProfileSaved();
    unsubscribeProfileShortlisted();
    unsubscribeRequestPendingForConnect();
    unsubscribeRequestedToConnect();
    unsubscribePrivacySetting();
    dispatch(clearMemberTopImages());
    dispatch(clearMemberPrivacy());
    dispatch(clearMembersPartnerPreference());
    dispatch(clearMemberProfile());
  };
  return unsubscribe;
};
/* ---------------------------------------------------
  VIEW MEMBER PRIVACY SUCCESS
----------------------------------------------------- */
const viewMemberPrivacySuccess = payload => ({
  type: profileConstants.GET_MEMBER_PRIVACY,
  payload
});
/* ---------------------------------------------------
  VIEW MEMBER PROFILE SUCCESS
----------------------------------------------------- */
const viewMemberProfileSuccess = payload => ({
  type: profileConstants.VIEW_MEMBER_PROFILE,
  payload
});

/* ---------------------------------------------------
  CHANGED PROFILE LIKED STATUS
----------------------------------------------------- */
const changeProfileLikedStatus = payload => ({
  type: profileConstants.CHANGE_PROFILE_LIKED_STATUS,
  payload
});

/* ---------------------------------------------------
  CHANGED PROFILE INTEREST STATUS
----------------------------------------------------- */
const changeProfileInterestStatus = payload => ({
  type: profileConstants.CHANGE_PROFILE_INTEREST_STATUS,
  payload
});

/* ---------------------------------------------------
  CHANGED PROFILE SHORTLISTED STATUS
----------------------------------------------------- */
const changeProfileShortlistedStatus = payload => ({
  type: profileConstants.CHANGE_PROFILE_SHORTLISTED_STATUS,
  payload
});

/* ---------------------------------------------------
  CHANGED PROFILE SAVED STATUS
----------------------------------------------------- */
const changeProfileSavedStatus = payload => ({
  type: profileConstants.CHANGE_PROFILE_SAVED_STATUS,
  payload
});

/* ---------------------------------------------------
  CHANGED PROFILE ADDED TO FAVORITE STATUS
----------------------------------------------------- */
const changeProfileAddedToFavoriteStatus = payload => ({
  type: profileConstants.CHANGE_PROFILE_ADDED_TO_FAVORITE,
  payload
});

/* ---------------------------------------------------
  CHANGED REQUEST PENDING FOR CONNECT STATUS
----------------------------------------------------- */
const changeRequestPendingForConnectStatus = payload => ({
  type: profileConstants.CHANGE_REQUEST_PENDING_FOR_CONNECT,
  payload
});

/* ---------------------------------------------------
  CHANGED REQUESTED TO CONNECT STATUS
----------------------------------------------------- */
const changeRequestedToConnectStatus = payload => ({
  type: profileConstants.CHANGE_REQUESTED_TO_CONNECT,
  payload
});
/* ---------------------------------------------------
  CHANGED CONNECTED STATUS
----------------------------------------------------- */
const changeConnectedStatus = payload => ({
  type: profileConstants.CHANGE_CONNECTED,
  payload
});
/* ---------------------------------------------------
  CONNECT MEMBER
----------------------------------------------------- */
export const connectMember = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .connectProfile(profileId)
    .then(() => {
      dispatch(connectMemberSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};
/* ---------------------------------------------------
  CONNECT MEMBER SUCCESS
----------------------------------------------------- */
const connectMemberSuccess = payload => ({
  type: profileConstants.CONNECT_MEMBER,
  payload
});

/* ---------------------------------------------------
  APPROVE CONNECT TO MEMBER
----------------------------------------------------- */
export const approveConnectToMember = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .approveConnect(profileId)
    .then(() => {
      dispatch(approveConnectToMemberSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};
/* ---------------------------------------------------
  APPROVE CONNECT TO MEMBER SUCCESS
----------------------------------------------------- */
const approveConnectToMemberSuccess = payload => ({
  type: profileConstants.APPROVE_CONNECT_TO_MEMBER,
  payload
});
/* ---------------------------------------------------
  DISCONNECT WITH MEMBER
----------------------------------------------------- */
export const disconnectWithMember = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .disconnect(profileId)
    .then(() => {
      dispatch(approveConnectToMemberSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  DISCONNECT WITH MEMBER SUCCESS
----------------------------------------------------- */
const disconnectWithMemberSuccess = payload => ({
  type: profileConstants.DISCONNECT_WITH_MEMBER,
  payload
});

/* ---------------------------------------------------
  LIKE MEMBER
----------------------------------------------------- */
export const likeMember = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .likeProfile(profileId)
    .then(() => {
      dispatch(likeMemberProfileSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};
/* ---------------------------------------------------
  LIKE MEMBER PROFILE SUCCESS
----------------------------------------------------- */
const likeMemberProfileSuccess = payload => ({
  type: profileConstants.LIKE_MEMBER_PROFILE,
  payload
});

/* ---------------------------------------------------
  UNLIKE MEMBER
----------------------------------------------------- */
export const unlikeMember = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .unlike(profileId)
    .then(() => {
      dispatch(unlikeMemberProfileSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};
/* ---------------------------------------------------
  UNLIKE MEMBER PROFILE SUCCESS
----------------------------------------------------- */
const unlikeMemberProfileSuccess = payload => ({
  type: profileConstants.UNLIKE_MEMBER_PROFILE,
  payload
});

/* ---------------------------------------------------
 EXPRESS INTEREST
----------------------------------------------------- */
export const expressInterest = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .expressInterest(profileId)
    .then(() => {
      dispatch(expressInterestSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  EXPRESS INTEREST SUCCESS
----------------------------------------------------- */
const expressInterestSuccess = payload => ({
  type: profileConstants.EXPRESS_INTEREST,
  payload
});

/* ---------------------------------------------------
 CANCEL EXPRESS INTEREST
----------------------------------------------------- */
export const cancelExpressInterest = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .cancelExpressInterest(profileId)
    .then(() => {
      dispatch(cancelExpressInterestSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  CANCEL EXPRESS INTEREST SUCCESS
----------------------------------------------------- */
const cancelExpressInterestSuccess = payload => ({
  type: profileConstants.CANCEL_EXPRESS_INTEREST,
  payload
});

/* ---------------------------------------------------
 SHORTLIST
----------------------------------------------------- */
export const shortlist = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .shortlist(profileId)
    .then(() => {
      dispatch(shortlistSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  SHORTLIST SUCCESS
----------------------------------------------------- */
const shortlistSuccess = payload => ({
  type: profileConstants.SHORTLIST,
  payload
});

/* ---------------------------------------------------
 REMOVE FROM SHORTLIST
----------------------------------------------------- */
export const removeFromShortlist = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .removeShortlist(profileId)
    .then(() => {
      dispatch(removeFromShortlistSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  REMOVE FROM SHORTLIST SUCCESS
----------------------------------------------------- */
const removeFromShortlistSuccess = payload => ({
  type: profileConstants.REMOVE_FROM_SHORTLIST,
  payload
});

/* ---------------------------------------------------
 SAVE
----------------------------------------------------- */
export const save = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .saveProfile(profileId)
    .then(() => {
      dispatch(saveSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  SAVE SUCCESS
----------------------------------------------------- */
const saveSuccess = payload => ({
  type: profileConstants.SAVE,
  payload
});

/* ---------------------------------------------------
 REMOVE FROM SAVED
----------------------------------------------------- */
export const removeFromSaved = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .removeSavedProfile(profileId)
    .then(() => {
      dispatch(removeFromSavedSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  REMOVE FROM SAVED SUCCESS
----------------------------------------------------- */
const removeFromSavedSuccess = payload => ({
  type: profileConstants.REMOVE_FROM_SAVED,
  payload
});

/* ---------------------------------------------------
 ADD TO FAVORITE
----------------------------------------------------- */
export const addToFavorite = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .addProfileToFavorite(profileId)
    .then(() => {
      dispatch(addToFavoriteSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  ADD TO FAVORITE SUCCESS
----------------------------------------------------- */
const addToFavoriteSuccess = payload => ({
  type: profileConstants.ADD_TO_FAVORITE,
  payload
});

/* ---------------------------------------------------
 REMOVE FROM ADD TO FAVORITE
----------------------------------------------------- */
export const removeFromAddToFavorite = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .removeFromFavorite(profileId)
    .then(() => {
      dispatch(removeFromAddToFavoriteSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  REMOVE FROM ADD TO FAVORITE SUCCESS
----------------------------------------------------- */
const removeFromAddToFavoriteSuccess = payload => ({
  type: profileConstants.REMOVE_FROM_ADD_TO_FAVORITE,
  payload
});

/* ---------------------------------------------------
  GET MEMBERS PARTNER PREFERENCE
----------------------------------------------------- */
export const getMembersPartnerPreference = payload => dispatch => {
  const { profileId, onSuccess, onError } = payload;

  profileService
    .getPartnerPreference(profileId)
    .then(response => {
      dispatch(getMembersPartnerPreferenceSuccess(response));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError();
      }
    });
};

/* ---------------------------------------------------
  GET MEMBERS PARTNER PREFERENCE SUCCESS
----------------------------------------------------- */
const getMembersPartnerPreferenceSuccess = payload => ({
  type: profileConstants.GET_MEMBERS_PARTNER_PREFERENCE,
  payload
});

/* ---------------------------------------------------
  CLEAR MEMBERS PARTNER PREFERENCE
----------------------------------------------------- */
const clearMembersPartnerPreference = payload => ({
  type: profileConstants.CLEAR_MEMBERS_PARTNER_PREFERENCE,
  payload
});

/* ---------------------------------------------------
  GET MEMBER TOP IMAGES
----------------------------------------------------- */
export const getMemberTopImages = profileId => dispatch => {
  profileService
    .getTopImages(profileId)
    .then(response => {
      dispatch(getMemberTopImagesSuccess(response));
    })
    .catch(err => {
      dispatch(getMemberTopImagesSuccess([]));
    });
};

/* ---------------------------------------------------
  GET MEMBER TOP IMAGES SUCCESS
----------------------------------------------------- */
const getMemberTopImagesSuccess = payload => ({
  type: profileConstants.GET_MEMBER_TOP_IMAGES,
  payload
});
/* ---------------------------------------------------
  CLEAR MEMBER TOP IMAGES 
----------------------------------------------------- */
const clearMemberTopImages = payload => ({
  type: profileConstants.CLEAR_MEMBER_TOP_IMAGES,
  payload
});

/* ---------------------------------------------------
  GET MEMBER MOBILE NUMBER
----------------------------------------------------- */
export const getMemberMobileNumber = profileId => dispatch => {
  profileService
    .getMobile(profileId)
    .then(response => {
      dispatch(getMemberMobileNumberSuccess(response));
    })
    .catch(err => {
      dispatch(getMemberMobileNumberSuccess({ mobile: "" }));
    });
};

/* ---------------------------------------------------
  GET MEMBER MOBILE NUMBER SUCCESS
----------------------------------------------------- */
const getMemberMobileNumberSuccess = payload => ({
  type: profileConstants.GET_MEMBER_MOBILE_NUMBER,
  payload
});
/* ---------------------------------------------------
  CLEAR MEMBER MOBILE NUMBER 
----------------------------------------------------- */
const clearMemberMobileNumber = payload => ({
  type: profileConstants.CLEAR_MEMBER_MOBILE_NUMBER,
  payload
});

/* ---------------------------------------------------
  CLEAR MEMBER PRIVACY 
----------------------------------------------------- */
const clearMemberPrivacy = payload => ({
  type: profileConstants.CLEAR_MEMBER_PRIVACY,
  payload
});

/* ---------------------------------------------------
  GET MEMBER GALLERY IMAGES
----------------------------------------------------- */
export const getMemberGalleryImages = payload => dispatch => {
  const { profileId, onError } = payload;
  //PRIVACY SETTING
  let unsubscribeMemberGalleryImages = firestore
    .collection(Collection.USERS)
    .doc(profileId)
    .collection(Collection.PRIVACY_SETTING)
    .doc(profileId)
    .onSnapshot(snapshot => {
      if (snapshot.exists) {
        const privacy = snapshot.data();
        if (privacy.images) {
          dispatch(getMemberAllImages(profileId));
        } else {
          dispatch(clearMemberAllImages());
          onError();
        }
        dispatch(viewMemberPrivacySuccess(snapshot.data()));
      } else {
        if (onError) {
          onError();
        }
      }
    });
  return unsubscribeMemberGalleryImages;
};

/* ---------------------------------------------------
  GET MEMBER ALL IMAGES
----------------------------------------------------- */
export const getMemberAllImages = profileId => dispatch => {
  profileService
    .getAllImages(profileId)
    .then(response => {
      dispatch(getMemberAllImagesSuccess(response));
    })
    .catch(err => {
      dispatch(getMemberAllImagesSuccess([]));
    });
};

/* ---------------------------------------------------
  GET MEMBER ALL IMAGES SUCCESS
----------------------------------------------------- */
const getMemberAllImagesSuccess = payload => ({
  type: profileConstants.GET_MEMBER_ALL_IMAGES,
  payload
});
/* ---------------------------------------------------
  CLEAR MEMBER ALL IMAGES 
----------------------------------------------------- */
export const clearMemberAllImages = payload => ({
  type: profileConstants.CLEAR_MEMBER_ALL_IMAGES,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/profileActions.js